import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import GarageCTA from 'commons-garage/components/GarageCTA/GarageCTA.jsx';

const EmptyGarage = ({ isNewEnabled, isUsedEnabled, usedUrl }) => {
    return (
        <div className="empty-garage">
            <h3 className="sr-text is-bold">
                {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.GARAGE.TITLE')}
            </h3>
            <p className="sr-disclaimer">
                {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.GARAGE.SUBTITLE')}
            </p>
            <br />
            <ul className="earnings_listing">
                <li>
                    <icon className="icon-Crochet sr-sucessColor" />
                    {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.GARAGE.COMPARE_TEXT')}
                </li>
                <li>
                    <icon className="icon-Crochet sr-sucessColor" />
                    {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.GARAGE.CONFIGURE')}
                </li>
                <li>
                    <icon className="icon-Crochet sr-sucessColor" />
                    {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.GARAGE.TAKE_ACTION')}
                </li>
            </ul>
            <GarageCTA isNewEnabled={isNewEnabled} isUsedEnabled={isUsedEnabled} usedUrl={usedUrl} />
        </div>
    );
};

EmptyGarage.displayName = 'EmptyGarage';

EmptyGarage.propTypes = {
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
};

export default EmptyGarage;
